import { type GetGlobalDataFreshnessResponse } from '@autone/redux/data-ingestion';
import { type FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { type SerializedError } from '@reduxjs/toolkit/react';
import { type FC } from 'react';

import {
  DataFreshnessErrorPopover,
  DataFreshnessLoadingButton,
  DataFreshnessPopover,
} from './data-freshness-popover';

interface DataFreshnessWidgetProps {
  data?: GetGlobalDataFreshnessResponse;
  isLoading: boolean;
  isFetching: boolean;
  error?: FetchBaseQueryError | SerializedError;
}

export const DataFreshnessWidget: FC<DataFreshnessWidgetProps> = ({
  data,
  isLoading,
  isFetching,
  error,
}) => {
  if (isLoading || isFetching) {
    return <DataFreshnessLoadingButton />;
  }

  if (!data?.status) {
    return <DataFreshnessErrorPopover error={error} />;
  }

  return (
    <DataFreshnessPopover
      dataFreshnessStatus={data.status}
      uploadedDatasets={data.uploadedDatasets}
      generatedDatasets={data.generatedDatasets}
    />
  );
};
